import axios from 'axios';
import Cookies from 'js-cookie';

const APP_URL = process.env.REACT_APP_APP_BASE_URL;
const LOGIN_URL = process.env.REACT_APP_APP_BASE_URL + '/account/login';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://api.shortlister.local';
const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;
const COOKIE_ID = process.env.REACT_APP_COOKIE_ID;
const PREFIX = process.env.REACT_APP_PREFIX;
const FORBIDDEN_URL = '/error/403';

axios.defaults.baseURL = `${API_BASE_URL}${PREFIX}`;
axios.interceptors.request.use(
    (config) => {
        if (!config.url.includes('/public'))
            config.headers['Cookie-ID'] = Cookies.get(COOKIE_ID);
        config.headers['Client-ID'] = CLIENT_ID;
        config.headers['Client-Secret'] = CLIENT_SECRET;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use((response) => response, (error) => {
    // // whatever you want to do with the error

    if (window.location.href.includes('/public/'))
        return;

    if (error.response && error.response.status === 401) {
        const path = window.location.pathname;
        window.location.href = LOGIN_URL + '?messaging=' + JSON.stringify(path);
        return null;
    }
    // Handle any error that occurred during the API request
    console.error('Error on request:', error);
    window.location.href = APP_URL;
    throw error;
});

const get = async (url) => {
    try {
        const response = await axios.get(url);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }

        return response.data;
    } catch (error) {
        if (error.response?.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};

const patch = async (url, data) => {
    try {
        const response = await axios.patch(url, data);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }

        return response.data;
    } catch (error) {
        if (error.response?.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};

export {FORBIDDEN_URL, LOGIN_URL, get, patch}


